import * as React from 'react'

import { StyledInput } from './Input.glamorous'
import { StyledInputWrapper } from './InputWrapper.glamorous'

import { Label } from './components/Label/Label'

import './styles/Input.css'

export type Props = {
  error?: boolean;
  label?: string;
  last?: boolean;
}

export const Input: React.SFC<Props & React.InputHTMLAttributes<HTMLInputElement>> = ({
  className,
  label,
  ...props,
}) => {
  const { id } = props

  return (
    <StyledInputWrapper className={`input__custom ${className}`}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <StyledInput {...props} />
    </StyledInputWrapper>
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Input/Input.tsx